import './IsolatedMode.sass';

import { FC, useCallback } from 'react';
import { Button, Header, ScrollView } from '$uikit';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { Truncate } from '$shared/components';
import { useDispatch } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions } from '$store/main';

export const IsolatedMode: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const user = useCurrentUserInfo();

  const handleToggle = useCallback(() => {
    dispatch(toastActions.setToastLoading());
    Api.post<any, any>('/account/isolated', {
      enabled: !(user?.isolated ?? false),
    })
      .then((data) => {
        console.log(data);
        dispatch(
          batchActions(
            toastActions.setToastSuccess(),
            mainActions.setUsers({
              [data.user.id]: data.user,
            }),
          ),
        );
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  }, [user]);

  return (
    <>
      <Header showBackButton>{t('isolation_mode_title')}</Header>
      <ScrollView>
        <div className="IsolatedMode">
          <div className="IsolatedMode__text">
            <Truncate text={t('isolation_mode_text')} />
          </div>
          <div className="IsolatedMode__action">
            <Button
              mode={user?.isolated ? 'secondary' : 'default'}
              stretched={false}
              onClick={handleToggle}
            >
              {t(user?.isolated ? 'isolation_mode_disable' : 'isolation_mode_enable')}
            </Button>
          </div>
        </div>
      </ScrollView>
    </>
  );
};
